<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
      >
        <template #h__entity><div class="table-default__left">Entity</div></template>
        <template #entity="{ row }">
          <router-link v-if="row.lead" :to=" { name: 'leads-detail-advertising', params: { id: row.id } }" class="table-default__link-border">
            Lead (ID: {{ row.id }})
          </router-link>
          <router-link v-else :to=" { name: 'trengo-tickets-detail', params: { id: row.id } }" class="table-default__link-border">
            Ticket (Number: {{ row.number }})
          </router-link>
        </template>
        <template #source="{ row }">{{ row.source.name }}</template>
        <template #type="{ row }">{{ row.type.name }}</template>
        <template #status="{ row }">{{ row.status.name }}</template>
        <template #created_at="{ row }">{{ formatDateTime(row.created_at) }}</template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getCommonAdvertisingRequests } from '@/http'
import { format, parseISO } from 'date-fns'

export default {
  name: 'CRMAnalyticsAPI',
  data() {
    return {
      page_loaded: false,
      table: {
        items: [],
        columns: ['entity', 'source', 'type', 'status', 'created_at'],
        options: {
          headings: {
            'entity': 'Entity',
            'source': 'Source',
            'type': 'Type',
            'status': 'Status',
            'created_at': 'Created at',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader: false,
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      this.table_preloader = true
      getCommonAdvertisingRequests({ page: this.pagination.page, page_size: 20 })
        .then(response => {
          this.table.items = response.data.results
          this.pagination.pages = response.data.pages
          this.pagination.count = response.data.count
          this.page_loaded = true
          this.table_preloader = false
        })
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    formatDateTime(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    }
  },
}
</script>

